import { toast } from "@atoms"
import { createContext, useContext, useCallback } from "react"

interface IContext {
  onDismiss(): void
}
interface Props {
  id: string
}

const DissmissContext = createContext<IContext>(undefined!)

const DismissProvider: React.FC<Props> = ({ id, ...props }) => {
  const onDismiss = useCallback(() => toast.dismiss(id), [id])

  return <DissmissContext.Provider value={{ onDismiss }} {...props} />
}

function useOnDismiss() {
  const context = useContext(DissmissContext)
  if (!context)
    throw new Error("useOnDismiss must be used within DismissProvider")
  return context.onDismiss
}

export default DismissProvider
export { useOnDismiss }
